import { faClock } from '@fortawesome/pro-light-svg-icons';
import { Branch } from '@medprev-web-app/api-graphql-client';

import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { cn } from '@/utils/cn-tw-merge';

interface BranchOpeningHoursProps extends React.HTMLAttributes<HTMLDivElement> {
  branch: Branch;
}

export const BranchOpeningHours = ({ branch, className }: BranchOpeningHoursProps) => {
  return (
    <>
      {branch.formattedPeriods && branch.formattedPeriods.length > 0 && (
        <>
          <hr className="w-full bg-gray-300 my-3" />
          <section className={cn(className, 'w-full')}>
            <div className="flex items-start gap-2 mb-5">
              <Icon icon={faClock} className="text-gray-500 w-5 h-5 mt-1" />
              <Typography
                variant={TypographyVariant.MEDIUM_SUBTITLE}
                className="text-gray-800 text-xl font-semibold"
              >
                Horários de atendimento
              </Typography>
            </div>
            <div className="flex flex-col">
              <div className="space-y-1 mb-2">
                {branch.formattedPeriods.map((period, index) => (
                  <Typography
                    variant={TypographyVariant.BODY_TEXT}
                    key={index}
                  >
                    <span className="font-semibold">
                      {period.label}
                      :
                    </span>
                    {' '}
                    {period.hours}
                  </Typography>
                ))}
              </div>
              {branch.isOpenNow && (
                <Typography
                  variant={TypographyVariant.BODY_TEXT}
                  className="text-success-700 font-semibold"
                >
                  Aberto agora
                </Typography>
              )}
              <Typography
                variant={TypographyVariant.MEDIUM_BODY_TEXT}
                className="text-gray-500 mt-2"
              >
                Feriados podem afetar nossos horários de funcionamento.
              </Typography>
            </div>
          </section>
        </>
      )}
    </>
  );
};
